import { call, put } from "redux-saga/effects";
import { createTemplate, getTemplate, updateTemplate } from "../../../../Services/apiService";
import { createTemplateFailure, createTemplateSuccess, getTemplateFailure, getTemplateSuccess, updateTemplateFailure, updateTemplateSuccess } from "../../../Slices/templateSlice";

export function* getTemplateHandler(actions) {
    try {
        const response = yield call(getTemplate, actions?.payload);
        yield put(getTemplateSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getTemplateFailure(errResponse));
    }
}

export function* createTemplateHandler(actions) {
    try {
        const response = yield call(createTemplate, actions?.payload);
        yield put(createTemplateSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(createTemplateFailure(errResponse));
    }
}

export function* updateTemplateHandler(actions) {
    try {
        const response = yield call(updateTemplate, actions?.payload);
        yield put(updateTemplateSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(updateTemplateFailure(errResponse));
    }
}